module.exports = __webpack_public_path__ + "resource/img/train01.c9d6dc0a.png";